import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import {AltButton} from './button/alt_button.tsx';

interface OwnProps {
    className?: string;
    slides?: number;
    start?: number;
    infinite?: boolean;
}

export const OccasionSlider = ({className, children, slides, start, infinite}: React.PropsWithChildren<OwnProps>) => {
    const settings = {
        arrows: true,
        dots: true,
        infinite: infinite ?? (Array.isArray(children) && children.length > 1),
        speed: 500,
        slidesToShow: slides ?? 1,
        slidesToScroll: slides ?? 1,
        prevArrow: (
            <AltButton>
                <i className="fa-light fa-arrow-left" />
            </AltButton>
        ),
        nextArrow: (
            <AltButton>
                <i className="fa-light fa-arrow-right" />
            </AltButton>
        ),
    };

    return (
        <Slider className={className} initialSlide={start ?? 0} {...settings}>
            {children}
        </Slider>
    );
};
